import defaults from 'lodash/defaults'

const OpenDesc = {
  writable: false,
  configurable: false,
  enumerable: true,
}

const StealthDesc = defaults({ enumerable: false }, OpenDesc)

function _fuze(obj, name, value) {
  const desc = fuze._descriptor || OpenDesc
  desc.value = value
  Object.defineProperty(obj, name, desc)
  delete desc.value

  return obj
}

function prop(obj, key, getter) {
  const desc = fuze._descriptor || OpenDesc
  delete desc.writable
  desc.get = getter
  Object.defineProperty(obj, key, desc)
  delete desc.get
  desc.writable = false

  return obj
}

function props(obj, props, getter) {
  if (getter !== undefined) {
    prop(obj, props, getter)
  } else {
    props = props || obj

    for (getter in props) prop(obj, getter, props[getter])
  }

  return obj
}

function fuze(obj, props, val) {
  if (val !== undefined) {
    _fuze(obj, props, val)
  } else {
    props = props || obj

    for (val in props) _fuze(obj, val, props[val])
  }

  return obj
}

function nonEnumerable(obj, props, val) {
  fuze._descriptor = StealthDesc

  try {
    return fuze(obj, props, val)
  } finally {
    fuze._descriptor = null
  }
}

fuze(fuze, {
  nonEnumerable,
  props,
})

export default fuze

export { fuze, nonEnumerable }
